export class Property {
    constructor(defaultValue = undefined, ...types) {
        this.validTypes = [];
        this.currentType = "undefined";
        this.validTypes.push(...types);
        this.value = defaultValue;
    }
    setValue(value) {
        if (!this.isValidType(value)) {
            return false;
        }
        this.value = value;
        return true;
    }
    getValue() {
        return this.value;
    }
    getValueAs(_type) {
        // check Type
        return this.value;
    }
    getCurrentType() {
        return this.currentType;
    }
    isValidType(value) {
        const type = typeof value;
        return this.validTypes.includes(type);
    }
}
